var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveryOrderSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.424,
    height: 41.985,
    viewBox: "0 0 30.424 41.985",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "delivery-order",
    d: "M182.185,26.25V38.556a3.619,3.619,0,0,1-3.619,3.619H166.25V64.616a3.619,3.619,0,0,0,3.619,3.619h23.185a3.62,3.62,0,0,0,3.619-3.619V29.869a3.621,3.621,0,0,0-3.619-3.619Zm-10.868,30.4h10.134a.724.724,0,1,0,0-1.448H171.317a.724.724,0,1,0,0,1.448Zm14.478,0h5.791a.724.724,0,1,0,0-1.448h-5.791a.724.724,0,0,0,0,1.448ZM171.317,52.31h20.269a.724.724,0,1,0,0-1.448H171.317a.724.724,0,1,0,0,1.448Zm0-4.343h20.269a.724.724,0,1,0,0-1.448H171.317a.724.724,0,1,0,0,1.448Zm9.42-21.282L166.674,40.728h11.892a2.172,2.172,0,0,0,2.172-2.172Z",
    transform: "translate(-166.25 -26.25)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryOrderSvg);
export default __webpack_public_path__ + "static/media/DeliveryOrderSvg.daf65ae2932e35ae7bbe867935579dc8.svg";
export { ForwardRef as ReactComponent };